import type { ReactNode } from 'react';

export function SectionHeading({
  description,
  title,
}: {
  description?: ReactNode;
  title: ReactNode;
}) {
  return (
    <div className="grid gap-2">
      <h2 className="m-0 text-xl leading-tight font-semibold">{title}</h2>
      {description ? (
        <p className="m-0 text-base leading-relaxed text-muted-foreground">
          {description}
        </p>
      ) : null}
    </div>
  );
}
